import { Link } from "react-router-dom";
import { categories, articles } from "@/mocks/articles";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.label,
      item: item.href ? `https://hzljbj.cn${item.href}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-500 flex-wrap">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-xs text-foreground-400" />
            )}
            {item.href ? (
              <Link
                to={item.href}
                className="hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium whitespace-nowrap">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}

export function getCategoryBreadcrumb(slug: string) {
  const cat = categories.find((c) => c.slug === slug);
  return [
    { label: "首页", href: "/" },
    { label: cat?.name || "分类" },
  ];
}

export function getArticleBreadcrumb(slug: string) {
  const article = articles.find((a) => a.slug === slug);
  const cat = categories.find((c) => c.id === article?.category);
  const items: BreadcrumbItem[] = [
    { label: "首页", href: "/" },
  ];
  if (cat) {
    items.push({ label: cat.name, href: `/category/${cat.slug}` });
  }
  items.push({ label: article?.title || "文章详情" });
  return items;
}

export function getAboutBreadcrumb() {
  return [
    { label: "首页", href: "/" },
    { label: "关于我们" },
  ];
}